import React from "react";
import styles from "./apply-auto-match-blueprint-content.module.scss";
import closeIcon from "@src/assets/svg/close-icon.svg";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import backArrowBlueIcon from "@src/assets/svg/back-arrow-blue.svg";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { Button } from "@src/components/atoms/buttons/button/button";
import { ReplaceBlueprintGradientBox } from "@src/components/organisms/replace-blueprint-gradient-box/replace-blueprint-gradient-box";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { useApplyAutoMatchBlueprintContentHook } from "./use-apply-auto-match-blueprint-content-hook";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { useI18N } from "@src/language/language-context";

const cssClassName = "apply-selected-blueprint-content";

interface UseFindAutoMatchBlueprintModalContentHookTypes {
  selectedAutoMatchBlueprint: BlueprintsArrayObjectTypes;
  proposedBlueprintStructure: BlueprintsArrayObjectTypes;
  currentStructure: BlueprintsArrayObjectTypes;
  handleBackButtonClick: () => void;
  closeModal: () => void;
  handleApplyBlueprint: () => void;
}

interface ApplyAutoMatchBlueprintModalContentPropTypes {
  useHook?: () => UseFindAutoMatchBlueprintModalContentHookTypes;
}

export const ApplyAutoMatchBlueprintContent = ({
  useHook = useApplyAutoMatchBlueprintContentHook,
}: ApplyAutoMatchBlueprintModalContentPropTypes) => {
  const {
    selectedAutoMatchBlueprint,
    proposedBlueprintStructure,
    currentStructure,
    handleBackButtonClick,
    closeModal,
    handleApplyBlueprint,
  } = useHook();
  const i18n = useI18N();

  const texts = {
    subTitle: i18n("modules.applyAutoMatchBlueprint.subTitle"),
    title: i18n("modules.applyAutoMatchBlueprint.title"),
    description: i18n("modules.applyAutoMatchBlueprint.description"),
    replaceButton: i18n("modules.applyAutoMatchBlueprint.replaceButton"),
    cancelButton: i18n("modules.applyAutoMatchBlueprint.cancelButton"),
  };

  return (
    <div className={styles[cssClassName]}>
      <GlassyModalHeader
        title={texts.subTitle}
        leftIcon={backArrowBlueIcon}
        leftIconFunction={handleBackButtonClick}
        rightIcon={closeIcon}
        rightIconFunction={closeModal}
      />
      <HorizontalSeparator verticalMargin={16} />
      <div>
        <p className={styles[`${cssClassName}__title`]}>{texts.title}</p>
        <p className={styles[`${cssClassName}__description`]}>
          {texts.description}
        </p>
        <Spacer16 />
        {currentStructure && selectedAutoMatchBlueprint && (
          <ReplaceBlueprintGradientBox
            currentBlueprint={currentStructure}
            selectedBlueprint={selectedAutoMatchBlueprint}
          />
        )}
      </div>
      <HorizontalSeparator verticalMargin={16} />
      <FlexRowContainer>
        <Button
          fun={handleApplyBlueprint}
          text={texts.replaceButton}
          disabled={!proposedBlueprintStructure}
        />
        <Button
          fun={closeModal}
          variant="secondary"
          text={texts.cancelButton}
        />
      </FlexRowContainer>
    </div>
  );
};
